import { useEffect } from 'react';
import { demeterEmailSubscriptionsApi } from '../../../Apis/Apis';
import { DemeterEmailSubscriptionModel } from '../../../Generated/Raven-Demeter';
import useApiWithoutAutoExecute from '../../Apis/Hooks/useApiWithoutAutoExecute';
import ActionsCellButton from '../../Components/Tables/ActionsCellButton/ActionsCellButton';
import useLanguage from '../../Services/Language/useLanguageHook';
import styles from './EmailSubscriptionsPage.module.scss';

interface ISubscriptionActionsProps {
    subscription: DemeterEmailSubscriptionModel;
    handleChange: () => any;
}

const EmailSubscriptionActions: React.FC<ISubscriptionActionsProps> = (props: ISubscriptionActionsProps) => {
    const [translations] = useLanguage();

    const [, activateDemeterSubscription, activateDemeterSubscriptionResponse] = useApiWithoutAutoExecute(() =>
        demeterEmailSubscriptionsApi.activateDemeterEmailSubscription({
            demeterEmailSubscriptionGuid: props.subscription.demeterEmailSubscriptionGuid ?? '',
        }),
    );

    const [, deactivateDemeterSubscription, deactivateDemeterSubscriptionResponse] = useApiWithoutAutoExecute(() =>
        demeterEmailSubscriptionsApi.deactivateDemeterEmailSubscription({
            demeterEmailSubscriptionGuid: props.subscription.demeterEmailSubscriptionGuid ?? '',
        }),
    );

    const [, deleteDemeterSubscription, deleteDemeterSubscriptionResponse] = useApiWithoutAutoExecute(() =>
        demeterEmailSubscriptionsApi.deleteDemeterEmailSubscription(props.subscription.demeterEmailSubscriptionGuid),
    );

    useEffect(() => {
        if (activateDemeterSubscriptionResponse || deactivateDemeterSubscriptionResponse || deleteDemeterSubscriptionResponse) {
            props.handleChange();
        }
    }, [activateDemeterSubscriptionResponse, deactivateDemeterSubscriptionResponse, deleteDemeterSubscriptionResponse]);

    return (
        <div className={styles.email_subscriptions_actions_container}>
            <ActionsCellButton
                text={translations.actions.delete}
                handleClick={deleteDemeterSubscription}
                track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'DeleteEmailSubscriptionClicked' }}
            />
            {!props.subscription.active && (
                <ActionsCellButton
                    text={translations.actions.subscribe}
                    handleClick={activateDemeterSubscription}
                    track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'SubscribeEmailSubscriptionClicked' }}
                />
            )}
            {props.subscription.active && (
                <ActionsCellButton
                    text={translations.actions.unsubscribe}
                    handleClick={deactivateDemeterSubscription}
                    track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'UnsubscribeEmailSubscriptionClicked' }}
                />
            )}
        </div>
    );
};

export default EmailSubscriptionActions;
